module.exports = __webpack_public_path__ + "21cae5121b1e92c00c8aa5137ebafb08.png";